import React, { useEffect } from "react";
import {
  FaInstagram,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaGithub,
} from "react-icons/fa";
import AppText from "../../Hoock/AppText";
import AOS from "aos";
import "aos/dist/aos.css";

function Hero() {
  useEffect(() => {
    AOS.init({
      once: true,
    });
    window.scrollTo(0, 0);
  }, []);
  return (
    <section id="home" className="overflow-x-hidden pt-28">
      <div className="container">
        <div className="flex flex-wrap ">
          <div
            className="w-full self-center px-4 md:w-1/2 md:pt-10"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="300"
            data-aos-offset="100"
            data-aos-anchor-placement="top-bottom" >
            <p className="font-mukta text-sm font-semibold text-slate-700 md:text-xl">
              Hello🙂, <span className="text-primary"> I'm</span>
            </p>
            <div className="flex items-center">
              <h1 className="mt-1 font-mukta text-3xl font-bold capitalize text-primary lg:text-5xl">
                Khairul
              </h1>
              <span
                className="ml-1 h-9 w-[85px]
               rotate-6 rounded-md  bg-primary text-center text-3xl font-bold leading-[36px] text-white"
              >
                Hadi
              </span>
            </div>

            {<AppText />}
            <p className="mt-2 text-sm font-medium text-slate-500 md:text-base">
              As a front end web developer, i specialize in creating visually
              appealing and user-friendly websites using HTML, CSS, Tailwind,
              and React to deliver customized web solutions that meet your
              unique requirements.
            </p>
            <a
              href="https://instagram.com/dyy_rul07?igshid=YmMyMTA2M2Y="
              className="mt-5 inline-block rounded-full bg-primary px-8 py-3   text-base font-semibold text-white shadow-lg transition duration-300 ease-in-out hover:-translate-y-1 hover:bg-cyan-300 hover:shadow-lg"
            >
              Let's Talk
            </a>
            <div className="mt-6 flex self-center">
              <div className="items-center">
                <h3 className="py-3 pr-1 text-center font-mukta font-semibold text-slate-700">
                  Check Out My
                </h3>
              </div>

              <div className="w-1 items-center p-4">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://instagram.com/dyy_rul07?igshid=YmMyMTA2M2Y="
                >
                  <FaInstagram
                    size={18}
                    className="mx-auto text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                  />
                </a>
              </div>
              <div className="w-1 items-center p-4">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.facebook.com/profile.php?id=100078541170035&mibextid=ZbWKwL"
                >
                  <FaFacebook
                    size={18}
                    className="mx-auto  text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                  />
                </a>
              </div>
              <div className="w-1 items-center p-4">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://twitter.com/ElhadiKhair?t=tuXc8rDOhZSmBBP90kIgnA&s=09"
                >
                  <FaTwitter
                    size={18}
                    className="mx-auto  text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                  />
                </a>
              </div>
              <div className="w-1 items-center p-4">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.linkedin.com/in/khairul-hadi-a51598222"
                >
                  <FaLinkedin
                    size={18}
                    className="mx-auto  text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                  />
                </a>
              </div>
              <div className="w-1 items-center p-4">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/dyyrul"
                >
                  <FaGithub
                    size={18}
                    className="mx-auto  text-primary transition duration-300 hover:-translate-y-1 hover:text-slate-950"
                  />
                </a>
              </div>
            </div>
          </div>
          <div
            className="w-full self-end overflow-hidden px-4 md:w-1/2 md:pb-10"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="300"
            data-aos-offset="100"
            data-aos-anchor-placement="top-bottom">
            <div className="relative -left-2 mt-10 lg:right-10 lg:mt-9">
              <img
                src="./img/hady.png"
                alt="hadi"
                className="mx-auto max-w-full md:w-[500px] "
              />
              <span className="absolute -bottom-0 left-[57%] -z-10 -translate-x-1/2 md:scale-125">
                <svg
                  width={400}
                  height={500}
                  viewBox="0 0 200 200"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#06b6d4"
                    d="M39.6,-63.8C51.6,-53.9,61.8,-43.4,69,-30.6C76.2,-17.9,80.3,-2.9,79.5,12.3C78.6,27.4,72.8,42.7,62.2,52.7C51.7,62.7,36.4,67.4,22.3,67.8C8.2,68.3,-4.8,64.4,-16.7,59.6C-28.5,54.8,-39.3,49.1,-51.1,41.1C-62.9,33.2,-75.8,23,-81,9.6C-86.1,-3.8,-83.5,-20.4,-74.6,-31.6C-65.7,-42.9,-50.4,-48.8,-36.9,-58C-23.4,-67.2,-11.7,-79.8,1,-81.4C13.8,-83,27.6,-73.7,39.6,-63.8Z"
                    transform="translate(100 100)"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
